import type {SalesPerformanceEntry} from 'src/types/sales-performance-analytics';

import type {SalesPerformanceAnalyticsActions} from 'src/action-creators/sales-performance-list';
import {
  RECEIVE_SALES_LIST,
  REFETCH_SALES_PERFORMANCE_LIST,
} from 'src/action-creators/sales-performance-list';


export type SalesPerformanceAnalyticsState = {
  lists: SalesPerformanceEntry[];
  refetch: boolean;
};

const initialState = {
  lists: [],
  refetch: false,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly lists: readonly []; readonly refetch: false; }' is not assignable to type 'SalesPerformanceAnalyticsState'.
  state: SalesPerformanceAnalyticsState | null | undefined = initialState,
  action: SalesPerformanceAnalyticsActions,
): SalesPerformanceAnalyticsState => {
  switch (action.type) {
    case RECEIVE_SALES_LIST: {
      const lists = action.payload;
      // @ts-expect-error - TS2322 - Type '{ lists: SalesPerformanceEntry[]; refetch?: boolean | undefined; }' is not assignable to type 'SalesPerformanceAnalyticsState'.
      return {
        ...state,
        lists,
      };
    }
    case REFETCH_SALES_PERFORMANCE_LIST: {
      // @ts-expect-error - TS2322 - Type '{ refetch: boolean; lists?: SalesPerformanceEntry[] | undefined; }' is not assignable to type 'SalesPerformanceAnalyticsState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        refetch: !state.refetch,
      };
    }
    default:
      // @ts-expect-error - TS2322 - Type '{ lists?: SalesPerformanceEntry[] | undefined; refetch?: boolean | undefined; }' is not assignable to type 'SalesPerformanceAnalyticsState'.
      return {...state};
  }
};
